import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/buttons/buttons";
import Input from "../../../../components/inputs/inputs";
import { history } from "../../../../helpers/history";
import { Beat } from "../../../../plugins/spinners.plugin";
import { XIcon } from "@heroicons/react/outline";
import Warning from "../../../../assets/images/icons/warning-circle.svg";
import AddMerchVariationModal from "../../../../components/modals/admin/addMerchVariationModal";
import { createAMerchandise } from "../../../../redux/merchandise/merchandiseActions";
import {
  getTeamFromCookies,
  getOutletFromCookies,
} from "../../../../utils/Auth";
import { cleanInput } from "../../../../helpers/cleanInput";
import SelectableInput from "../../../../components/inputs/SelectableInput";
import { ReactComponent as UploadIcon } from "../../../../assets/images/icons/upload.svg";
import { filterProductCategory } from "../../../../redux/productCatergory/productCategoryAction";
import { filterProductTag } from "../../../../redux/productTags/productTagActions";
import { filterAttributeAction } from "../../../../redux/attribute/attributeActions";
import RemoveMerchAttributeModal from "../../../../components/modals/admin/attributes/removeMerchAttributeModal";

export default function CreateMerchandise() {
  const dispatch = useDispatch();
  const team = getTeamFromCookies();
  const outlet = getOutletFromCookies();
  const hiddenFileInput = useRef(null);

  const { allCategories } = useSelector((state) => state.productCatergory);
  const { allTags } = useSelector((state) => state.productTag);
  const { isLoading } = useSelector((state) => state.merchandise);

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedArr, setSelectedArr] = useState([]);
  const [displayArr, setDisplayArr] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [images, setImages] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [image64, setImage64] = useState([]);
  const [data, setData] = useState({
    store_id: outlet?.id,
    business_id: team,
    merchandise_name: "",
    merchandise_description: "",
    merchandise_categories: [],
    merchandise_tags: [],
    merchandise_amount: "",
    merchandise_operating_status: "",
    merchandise_discount: 0,
    merchandise_attributes: [],
    stock: "",
    base64_photos: "",
    format: "",
  });
  const {
    merchandise_name,
    merchandise_description,
    merchandise_categories,
    merchandise_tags,
    merchandise_amount,
    stock,
    format,
  } = data;

  useEffect(() => {
    dispatch(filterProductCategory({ type: "store" }, 1));
    dispatch(filterProductTag({ type: "store" }, 1));
    dispatch(filterAttributeAction({ business_id: team }));
    // eslint-disable-next-line
  }, []);

  const storeCategories = allCategories?.data?.filter((item) => {
    return item?.type === "store";
  });
  const storeTags = allTags?.data?.filter((item) => {
    return item?.type === "store";
  });

  function closeModal() {
    setIsOpen(false);
  }
  function openModal() {
    setIsOpen(true);
  }

  const handleToggleTags = (value) => {
    const former_tags = [...data?.merchandise_tags];
    if (former_tags.includes(value)) {
      let arr = [...former_tags];
      const filtered = arr.filter((item) => item !== value);
      setData({ ...data, merchandise_tags: filtered });
    } else {
      let new_tags = [...former_tags, value.name];
      setData({ ...data, merchandise_tags: new_tags });
    }
  };

  const handleToggleCategories = (value) => {
    const former_categories = [...data?.merchandise_categories];
    if (former_categories.includes(value)) {
      let arr = [...former_categories];
      const filtered = arr.filter((item) => item !== value);
      setData({ ...data, merchandise_categories: filtered });
    } else {
      let new_categories = [...former_categories, value.name];
      setData({ ...data, merchandise_categories: new_categories });
    }
  };

  function onImageChange(e) {
    setImages([...e.target.files]);
  }

  const handleFileClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  const removeFile = (index) => {
    let newArr = images;
    newArr.splice(index, 1);
    setImages([...newArr]);
  };

  useEffect(() => {
    const newImageUrls = [];
    const newImage64 = [];
    images?.forEach((image) => {
      newImageUrls.push(URL.createObjectURL(image));
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        newImage64.push(reader.result);
      };
    });
    setImageUrls(newImageUrls);
    setImage64(newImage64);
  }, [images]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    event.preventDefault();
    setData((data) => ({ ...data, [name]: value }));
  };

  function getFoodWithCategories() {
    let titleArr = [];
    let newArray = [];
    for (let index = 0; index < selected?.length; index++) {
      if (!titleArr.includes(selected[index].title)) {
        titleArr.push(selected[index].title);
      }
    }
    for (let index = 0; index < titleArr?.length; index++) {
      let temp = {
        title: titleArr[index],
        attributes: selected.filter((food) => titleArr[index] === food.title),
      };
      newArray.push(temp);
    }
    return newArray;
  }
  useEffect(() => {
    const merchAttr = getFoodWithCategories();
    setDisplayArr(merchAttr);
    // eslint-disable-next-line
  }, [selected]);

  const handleSubmit = async () => {
    setSubmitted(true);
    let newData = {
      ...data,
      base64_photos: image64 ? image64 : [],
      merchandise_attributes: selectedArr,
    };
    cleanInput(newData);

    if (
      merchandise_name &&
      merchandise_description &&
      merchandise_description.length > 10 &&
      merchandise_categories &&
      merchandise_amount &&
      merchandise_tags
    ) {
      try {
        const response = await dispatch(
          createAMerchandise({
            ...newData,
          })
        );
        if (response?.status === "success") {
          history(`/admin/${outlet?.store_name}/merchandise/inactive/1`);
        }
      } catch (error) {
        console.log(error);
        history(`/admin/${outlet?.store_name}/merchandise/inactive/1`);
      }
    }
  };
  return (
    <>
      {/* <div className="mb-10">
        <h1 className="text-3xl font-semibold text-gray-900">
          Merchandise / Create Merchandise
        </h1>
      </div> */}
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8">
          <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
            <h3 className="text-lg font-medium">Merchandise Details</h3>

            <Button.Primary
              title={
                isLoading ? <Beat color={"#ffffff"} /> : "Create Merchandise"
              }
              form="merch_form"
              onClick={handleSubmit}
              type={"button"}
              disabled={isLoading}
              className="hidden sm:block rounded-sm"
            />
          </div>
          <div className="mt-6">
            <div
              className={
                submitted && !merchandise_name ? "  border-red-500" : ""
              }
            >
              <Input.Label
                title={"Merchandise Name*"}
                htmlFor={"merchandise_name"}
                name="merchandise_name"
                onChange={handleChange}
                placeholder="Enter merchandise name"
              />
              {submitted && !merchandise_name && (
                <div className="text-primary text-xs ">
                  Merchandise name is required
                </div>
              )}
            </div>
            <div
              className={
                submitted && merchandise_description ? "  border-red-500" : ""
              }
            >
              <Input.Label
                title={
                  "Short Description (Hint: Input product Highlights/Features in bullets. Not more than 200 Characters)"
                }
                htmlFor={"merchandise_description"}
                name="merchandise_description"
                defaultValue={data.merchandise_description}
                onChange={handleChange}
                placeholder="Enter a short merchandise description"
              />
              {merchandise_description &&
                merchandise_description.length < 10 && (
                  <div className="text-xs text-red-500">
                    Merchandise description must be a minimum than 10 characters
                  </div>
                )}
              {submitted && !merchandise_description && (
                <div className="text-xs text-red-500">
                  Merchandise description is required
                </div>
              )}
            </div>

            <div className="grid grid-cols-1 ">
              <div>
                <Input.Label
                  title={"Stock*"}
                  htmlFor={"stock"}
                  name="stock"
                  placeholder="Enter Quantity"
                  onChange={handleChange}
                />
                {submitted && !stock && (
                  <div className="text-primary text-xs ">Stock is required</div>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div
                className={
                  submitted && !merchandise_amount ? "  border-red-500" : ""
                }
              >
                <Input.Number
                  title={"Price*"}
                  htmlFor={"merchandise_amount"}
                  name="merchandise_amount"
                  placeholder="Enter merchandise price"
                  onChange={handleChange}
                />
                {submitted && !merchandise_amount && (
                  <div className="text-primary text-xs ">
                    Merchandise amount is required
                  </div>
                )}
              </div>
              <div>
                <Input.Number
                  title={"Discounted Price"}
                  name="merchandise_discount"
                  htmlFor={"merchandise_discount"}
                  onChange={handleChange}
                  placeholder="0"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <Input.Select
                title={"Product Type"}
                htmlFor={"format"}
                name={"format"}
                value={format}
                onChange={handleChange}
              >
                <option>Select Product Type</option>
                <option value={"physical"}>Physical Product</option>
                <option value={"digital"}>Digital Product</option>
              </Input.Select>

              <Input.Select
                title={"Split Payment Available?"}
                // htmlFor={"format"}
                // name={"format"}
                // value={format}
                // onChange={handleChange}
              >
                <option value={"no"}>No</option>
                {/* <option value={"yes"}>Yes</option> */}
              </Input.Select>
            </div>

            {/* Split payment section */}
            <div className="mt-8">
              {/* <div className="py-3 mb-2 flex justify-between items-center">
                <h3 className="text-lg font-medium">*Split Payment Setup*</h3>
                <Button.Primary
                  title={
                    isLoading ? <Beat color={"#ffffff"} /> : "Close Process"
                  }
                  onClick={handleSubmit}
                  className="px-5"
                  type={"button"}
                  disabled={isLoading}
                />
              </div>
              <Input.Label
                title={"Split Payment Name"}
                type="text"
                name="restaurant_id"
                id="restaurant_id"
                className="w-full border border-[#E4E4F3] bg-[#F3F3F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="This is the designated name for describing the plan in notification messages."
                onChange={handleChange}
              />
              <Input.Number
                title={"Initial Payment"}
                type="number"
                name="food_amount"
                id="food_amount"
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="This is the initial payment required before releasing the product to the customer."
                onChange={handleChange}
              />
              <Input.Number
                title={"Subsequent Payment Amount (£)"}
                type="number"
                name="food_amount"
                id="food_amount"
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="This is the fee for each recurring payment from the customer"
                onChange={handleChange}
              />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                <div>
                  <Input.Number
                    title={"Payment Frequency/Intervals"}
                    type="number"
                    name="food_amount"
                    id="food_amount"
                    className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                    placeholder="This can be monthly, quarterly, yearly e.t.c"
                    onChange={handleChange}
                  />
                </div>

                <Input.Number
                  title={"Duration"}
                  type="number"
                  name="food_discount"
                  id="food_discount"
                  className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                  placeholder="This is the duration the plan should endure in terms of intervals"
                  onChange={handleChange}
                />
              </div> */}

              {/* notice */}
              {/* <div className="mt-1 py-2 flex gap-3">
                <img
                  src={Warning}
                  alt="warning"
                  className="w-[18px] h-[18px]"
                />
                <p className="text-sm text-[#333333]">
                  Without a specified duration, we'll bill the customer until
                  cancellation.
                </p>
              </div> */}
              {/* notice */}
              <div className="mt-1 py-2 flex gap-3">
                <img
                  src={Warning}
                  alt="warning"
                  className="w-[18px] h-[18px]"
                />
                <p className="text-sm text-[#333333]">
                  The default currency for charging is set to Naira
                </p>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="border border-[#E4E4F3] bg-white  rounded-md py-5 px-8 mt-8">
          <div
            className={
              submitted && merchandise_categories.length < 1
                ? "  border-red-500"
                : ""
            }
          >
            <label
              htmlFor="merchandise_categories"
              className="text-sm font-medium text-[#151515]"
            >
              Merchandise Categories
            </label>
            <SelectableInput
              options={storeCategories}
              label="merchandise_categories"
              name={"+ Add Category"}
              type="category"
              selectOption={handleToggleCategories}
            />
            {submitted && merchandise_categories.length < 1 && (
              <div className="text-primary text-xs ">
                Merchandise category is required
              </div>
            )}
          </div>
        </div>
        <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8 mt-8">
          <div
            className={
              submitted && merchandise_tags.length < 1 ? "  border-red-500" : ""
            }
          >
            <label
              htmlFor="merchandise_tags"
              className="block text-sm font-medium text-gray-700"
            >
              Merchandise Tags
            </label>
            <div className="mt-2 ">
              <SelectableInput
                options={storeTags}
                label="merchandise_tags"
                name={"+ Add Tag"}
                type="tag"
                selectOption={handleToggleTags}
              />
              {submitted && merchandise_tags.length < 1 && (
                <div className="text-primary text-xs ">
                  Merchandise tag is required
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8 mt-8">
        <div className="border-b border-[#E4E4F3] py-3 items-center">
          <div>
            <h3 className="text-lg font-medium">
              Merchandise Image (200px by 200px)
            </h3>
            <p className="text-sm">
              Accepts .jpg, .png and .jpeg image formats
            </p>
          </div>
        </div>
        {imageUrls?.length === 0 ? (
          <div className="bg-[#FFFBFA] text-center border border-dashed border-[#E4E4F3] rounded-[10px] mt-4 p-5 h-[130px]">
            <button className="text-primary mx-auto" onClick={handleFileClick}>
              <UploadIcon className="h-[56px] w-[56px]" />
            </button>
            <input
              type="file"
              className="hidden"
              accept="image/*"
              onChange={onImageChange}
              ref={hiddenFileInput}
            />
            <p className="text-[#676565] text-lg text-center mt-1">
              Click here to select a photo
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-6 gap-8 mt-8">
            {imageUrls?.map((image, index) => (
              <figure className="w-full h-[160px] relative" key={index}>
                <img
                  src={image}
                  className="object-cover w-full h-full"
                  alt="food"
                />
                <button
                  type="button"
                  className="h-8 w-8 bg-[#FAE9E6] rounded-full absolute right-2 top-2"
                  onClick={() => removeFile(index)}
                >
                  <XIcon className="h-5 w-5 text-primary mx-auto" />
                </button>
              </figure>
            ))}
          </div>
        )}
      </div>

      <div className="border border-[#E4E4F3] bg-white rounded-md py-5 px-8 mt-8 mb-8">
        <div className="border-b border-[#E4E4F3] py-3 flex  items-center">
          <h3 className="text-lg font-medium">Merchandise Attributes</h3>
        </div>
        <AddMerchVariationModal
          show={isOpen}
          onClose={closeModal}
          selected={selected}
          setSelected={setSelected}
          selectedArr={selectedArr}
          setSelectedArr={setSelectedArr}
        />
        {displayArr?.length > 0 ? (
          displayArr?.map((attr, i) => (
            <div key={i} className="border-b border-[#E4E4F3] mt-8">
              <p className="text-md my-6">
                Title : <span className="font-medium">{attr.title}</span>
              </p>
              <div className="grid grid-cols-3 gap-24 px-4">
                <p className="py-2 text-md">Name</p>
                <p className="py-2 text-md">Value</p>
                <p className="py-2 text-md">Action</p>
              </div>
              {attr?.attributes?.map((attribute, i) => (
                <div key={i} className="grid grid-cols-3 gap-24 px-4">
                  <p className="py-2 font-medium">{attribute.name}</p>

                  <p className="py-2 font-medium">NGN {attribute.amount}</p>
                  <div>
                    <div className="flex justify-between max-w-[26px] py-2">
                      <RemoveMerchAttributeModal
                        id={attribute?.id}
                        myAttributes={attribute}
                        selected={selected}
                        setSelected={setSelected}
                        selectedArr={selectedArr}
                        setSelectedArr={setSelectedArr}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))
        ) : (
          <div className="text-center mx-auto max-w-2xl py-8">
            <h4 className="text-2xl font-medium mb-1">
              You have no merchandise Attributes yet
            </h4>
            <p className="text-lg">
              When you create new merchandise Attributes, it will be dispalyed
              here
            </p>
            <p
              className="text-primary text-lg cursor-pointer"
              onClick={openModal}
            >
              + Add Attributes
            </p>
          </div>
        )}
      </div>

      <div className="text-center">
        <Button.Primary
          title={isLoading ? <Beat color={"#ffffff"} /> : "Create Merchandise"}
          form="merch_form"
          onClick={handleSubmit}
          type={"button"}
          disabled={isLoading}
          className="sm:hidden rounded-sm"
        />
      </div>
    </>
  );
}
